import store from './store';
import main from '../src/components/main';
import './index.scss';


main(store);



// WEBPACK FOOTER //
// ./src/index.js